/* esm.sh - @smithy/types@4.14.2/dist-es/extensions */
export * from "/*@smithy/types@4.14.2/esnext/dist-es/extensions.mjs";
